import BaseWarehouseAndUser from "@/project/model/base/BaseWarehouseAndUser";

export default class BaseWareUserTime extends BaseWarehouseAndUser{

    startTime = '';
    endTime = '';

}